import axios from '../utils/axios'
import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { TokenResponse } from './signin'

export type RefreshToken = AxiosResponse<{
  data: TokenResponse
}>

const REFRESH_TOKEN_URL = process.env.REACT_APP_REFRESH_SESSION as string

export async function refreshToken(
  username: string,
  refreshToken: string,
  isSSO: boolean
): Promise<RefreshToken> {
  try {
    const config: AxiosRequestConfig = {
      method: 'POST',
      url: REFRESH_TOKEN_URL,
      data: { refreshToken, username },
      headers: isSSO ? { 'x-source': 'sso' } : undefined,
    }

    const refreshTokenResponse = await axios(config)
    return refreshTokenResponse
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      throw error.response ?? error
    }
    throw error
  }
}
